module.exports = __webpack_public_path__ + "static/media/battles-streak-info-2.30a8b731.png";